<template>
  <v-row>
    <v-col md="12">
      <v-card>
        <v-card-text>
          <ModuleHeader>Configuración de reservas</ModuleHeader>
          <v-row v-if="guessConfig">
            <v-col md="6">
              <v-select v-model="guessConfig.tarifario" :items="Catalogos.tarifarios" label="Tarifarios"></v-select>
            </v-col>
            <v-col md="6">
              <v-select v-model="guessConfig.categoria" :items="Catalogos.subcategorias" item-value="id"
                item-text="Nombre" label="Subcategorias"></v-select>
            </v-col>
          </v-row>
          <v-btn @click="saveConfig" color="green" class="mt-2" dark block>
            Guardar
          </v-btn>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>


<script>
import moment from "moment";
import TarifasClass from "../../clases/Tarifa.js";

export default {
  name: "configDays",
  components: {},
  props: [],
  data() {
    return {
      MainDepartamento: "",
      guessConfig: {
        tarifario: "",
        categoria: ""
      },
      Catalogos: {
        tarifarios: [],
        subcategorias: [],
      },
    };
  },
  methods: {
    async getTarifarios(dep) {
      let tarifarios = await TarifasClass.getMixTarifasCombo(
        dep
      );
      tarifarios.forEach((element) => {
        element.value = element.Id;
        element.text = element.Nombre;
      });
      this.Catalogos.tarifarios = tarifarios;
    },
    async getSubcategorias(dep) {
      this.horarios = [];
      /* obtiene el listado de temporadas activas en el sistema  */
      const data = await this.$store.getters.getFirebaseApp.database
        .queryBuilder(
          "RVA/Tarifas/" +
          dep +
          "/SubCategorias"
        )

      if (!data.exists()) {
        return false;
      }

      this.Catalogos.subcategorias = [];
      this.Catalogos.subcategorias = this.$pgsHelper.ArrayObjectToArray(
        data.val()
      );
    },
    saveConfig() {
      this.$alert.alertConfirm(
        {
          action: "guardar",
          obj: "la configuración",
          route: 'RVA-Configuracion-setConfiguracion',
          data: { Departamento: this.MainDepartamento, GUEST: this.guessConfig },
          onSuccess: () => {
            this.toggleModal(false);
          }
        }
      );
    },
    async getConfig() {
      const conf = await this.$store.getters.getFirebaseApp.database.queryBuilder("RVA/Configuracion/" + localStorage.getItem("selectedDepartment") + '');
      if (conf.exists()) {
        let resultConf = conf.val();
        this.guessConfig = resultConf?.GUEST;
      }

    }
  },
  watch: {},
  async mounted() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    this.getTarifarios(this.MainDepartamento);
    this.getSubcategorias(this.MainDepartamento);
    await this.getConfig();
  },
  created() { },
};
</script>